import React, { useEffect, useState } from "react";
import { usePreload } from "../hooks/usePreload";
// import { LogType } from "../types";
import "./Logs.css";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "./PageHeader";
import Pagination from "./Pagination";

const Logs: React.FC = () => {
  const preload = usePreload();
  const logs = preload.logs;
  const users = preload.users;

  const queryParams = new URLSearchParams(location.search);
  const lla = queryParams.get("lla"); // LiveLet admin page = 1

  const navigate = useNavigate();

  const [activeActions, setActiveActions] = useState<string[]>(["view"]);
  // const [pageSize, setPageSize] = useState<number>(10);
  const [pageSize, setPageSize] = useState<number>(() => {
    const saved = localStorage.getItem('pageSize');
    return saved ? parseInt(saved, 10) : 10;
  });
  const pageSizes = [10, 25, 50, 100];
  const [currentPage, setCurrentPage] = useState<number>(1);

  const types: Record<string, string> = { "deleteCard": "名刺削除", "view": "閲覧", "downloadCards": "ダウンロード", "scanCard": "スキャン", "saveImage-front": "名刺前面保存", "saveImage-back": "名刺背面保存", "login": "ログイン", "updateUser": "ユーザー編集", "deleteTag": "タグ削除", "saveCard": "名刺保存" };

  useEffect(() => {
    localStorage.setItem('pageSize', pageSize.toString());
  }, [pageSize]);

  const uniqueActions = logs ? Array.from(new Set(logs.map(log => log.action))) : [];

  const filteredLogs = logs?.filter(log => activeActions.includes(log.action));

  const totalPages = Math.ceil((filteredLogs?.length || 1) / pageSize);
  const pageControls = (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      pageSizeOptions={pageSizes}
      onPageChange={setCurrentPage}
      onPageSizeChange={(size) => { setPageSize(size); setCurrentPage(1); }}
    />
  );

  // 操作の種類で絞り込むボタン（押すと選択・解除）
  const actionToggles = (<div className="actionToggles">{uniqueActions.map(action => {
    const active = activeActions.includes(action);
    return (
      <button type="button" aria-pressed={active} className={`action-toggle${active ? " is-active" : ""}`} key={action} onClick={() => {
        if (activeActions.includes(action)) {
          setActiveActions(activeActions.filter(activeAction => activeAction !== action));
        } else {
          setActiveActions([...activeActions, action]);
        }
        setCurrentPage(1);
      }}>{types[action]}</button>
    )
  })}</div>);

  const pagenatedLogs = filteredLogs?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  // const logItems = (<div style={{ overflowY: "auto" }}>{pagenatedLogs?.map(log => {
  //   return (
  //     <div key={log.logKey} className="py-1">
  //       <span>{formatTimestamp(log.occuredAt)} - {LogToSentence(log)}</span>
  //     </div>
  //   )
  // })}</div>);

  // function LogToSentence(log: LogType): string | JSX.Element {
  //   const cards = preload?.cards;
  //   const actionUser = cards?.find(card => card.cardKey === log.userKey);
  //   const cardUser = cards?.find(card => card.cardKey === log.cardKey);
  //   const cardLink = (cardUser) ? (<Link to={`/camera/${cardUser.cardKey}`}>card #{cardUser.cardKey}</Link>) : "a card";

  //   switch (log.action) {
  //     case "deleteCard":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) deleted card #${log.cardKey}.`}</span>;
  //     case "login":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) logged in.`}</span>;
  //     case "downloadCards":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) downloaded cards.`}</span>;
  //     case "saveCard":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) saved `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     case "saveImage-front":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) saved image for the front of `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     case "saveImage-back":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) saved image for the back of `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     case "scanCard":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) scanned a card.`}</span>;
  //     case "updateUser":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) updated their profile.`}</span>;
  //     case "view":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) viewed `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     default:
  //       return `Unknown action: ${log.action} by user #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}).`;
  //   }
  // }

  const logContents = pagenatedLogs?.map(log => {
    const action = types[log.action] || "不明な操作";
    const cards = preload?.cards;
    const actionUserFromCards = cards?.find(card => card.cardKey === log.cardKey);
    const actionFirstNameFromCards = actionUserFromCards?.content.firstName?.find(name => name.language === "japanese")?.content || actionUserFromCards?.content.firstName?.[0]?.content;
    const actionLastNameFromCards = actionUserFromCards?.content.lastName?.find(name => name.language === "japanese")?.content || actionUserFromCards?.content.lastName?.[0]?.content;
    const actionNameFromCards = (actionFirstNameFromCards && actionLastNameFromCards) ? actionLastNameFromCards + ", " + actionFirstNameFromCards : null;
    const actionUserFromCompany = users?.find(user => user.userKey === log.userKey) || users?.find(user => user.externalUserKey === log.userKey);
    const actionFirstNameFromCompany = actionUserFromCompany?.firstName;
    const actionLastNameFromCompany = actionUserFromCompany?.lastName;
    const actionNameFromCompany = (actionFirstNameFromCompany && actionLastNameFromCompany) ? actionLastNameFromCompany + ", " + actionFirstNameFromCompany : null;
    const actionUserName = actionNameFromCards || actionNameFromCompany || '不明なユーザー';
    const cardUser = cards?.find(card => card.cardKey === log.cardKey);
    const cardLink = (cardUser) ? (<Link to={`/camera/${cardUser.cardKey}`} className="logList__link">詳細を表示</Link>) : "";
    const companyName = cardUser?.content.companyName?.[0].content ? cardUser?.content.companyName?.[1]?.content ? cardUser?.content.companyName?.[0].content : cardUser?.content.companyName?.[1]?.content : '';
    const cardName = (cardUser?.content.lastName?.[0]?.content ?? '') + (cardUser?.content.firstName?.[0]?.content ?? '');
    const title = cardUser?.content.title?.[0].content ? cardUser?.content.title?.[1]?.content ? cardUser?.content.title?.[0].content : cardUser?.content.title?.[1]?.content : '';

    return (
      <div key={log.logKey} className="logList__row">
        <div className="logList__cell">{formatTimestamp(log.occuredAt)}</div>
        <div className="logList__cell">{actionUserName}</div>
        <div className="logList__cell">{action}</div>
        <div className="logList__cell">{companyName}</div>
        <div className="logList__cell">{cardName}</div>
        <div className="logList__cell">{title}</div>
        <div className="logList__cell">{cardLink}</div>
      </div>
    )
  });


  return (
    <div className="top-page-container">
      <PageHeader title="閲覧履歴" showBack={lla !== "1"} />
      <div className="pageBody">
      {false && <p>Logs ({logs?.length}) will go here</p>}
      {false && <p>Unique Actions: {uniqueActions.join(", ")}</p>}
      {/* 絞り込みとページ送り（名刺の検索と同じ並び。PC は1行、スマホは縦に積む） */}
      <div className="searchToolbar logsToolbar">
        {/* 履歴が1件もないときは絞り込みのボタンが無いので、見出しごと出さない */}
        {uniqueActions.length > 0 ? (
          <div>
            <span className="c-label" id="action-label">操作の種類</span>
            <div role="group" aria-labelledby="action-label">{actionToggles}</div>
          </div>
        ) : <div />}
        <div>
          <span className="c-label" id="logs-paging-label">表示設定</span>
          <div role="group" aria-labelledby="logs-paging-label">{pageControls}</div>
        </div>
      </div>

      {/* 名刺の検索の表と同じ形（見出し行 #E4E4E4・行の下線・最後の行は線なし） */}
      <div className="logList drop-shadow-md">
        <div className="logList__table">
          <div className="logList__row logList__head">
            <div className="logList__cell">日付</div>
            <div className="logList__cell">操作ユーザー</div>
            <div className="logList__cell">操作種類</div>
            <div className="logList__cell">対象名刺会社名</div>
            <div className="logList__cell">対象名刺氏名</div>
            <div className="logList__cell">対象名刺役職</div>
            <div className="logList__cell">名刺を表示</div>
          </div>
          {logContents && logContents.length > 0 ? logContents : (
            <div className="logList__row"><div className="logList__cell logList__empty">表示する履歴はありません</div></div>
          )}
        </div>
      </div>
      </div>
    </div>
  );
}

export default Logs;

function formatTimestamp(occurredAt: string, timeZone: number = 9): string {
  // Parse the timestamp into a Date object
  const date = new Date(occurredAt);

  // Get the UTC time values
  const utcYear = date.getUTCFullYear();
  const utcMonth = date.getUTCMonth(); // 0-indexed
  const utcDate = date.getUTCDate();
  const utcHours = date.getUTCHours();
  const utcMinutes = date.getUTCMinutes();
  const utcSeconds = date.getUTCSeconds();

  // Adjust to the desired timezone
  const localHours = utcHours + timeZone;

  // Create a new Date object with adjusted hours
  const adjustedDate = new Date(Date.UTC(utcYear, utcMonth, utcDate, localHours, utcMinutes, utcSeconds));

  // Extract the adjusted values
  const year = adjustedDate.getUTCFullYear();
  const month = adjustedDate.getUTCMonth() + 1; // Convert to 1-indexed
  const day = adjustedDate.getUTCDate();
  const hours = adjustedDate.getUTCHours();
  const minutes = adjustedDate.getUTCMinutes();
  const seconds = adjustedDate.getUTCSeconds();

  // Format as "YYYY-MM-DD HH:MM:SS"
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ` +
    `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  return formattedDate;
}
